import ClientPackageHistoryPage from "./views/ClientPackageHistoryPage.vue";

const routes = [
  {
    path: "/client-package-history",
    name: "clientPackageHistory",
    component: ClientPackageHistoryPage,
  }
];

export default routes;
